import React from 'react';
import { Icon } from '../Icon/Icon';

export interface TriageUrgencyBannerProps {
  urgentCount: number;
  onJump?: () => void;
}

export function TriageUrgencyBanner({ urgentCount, onJump }: TriageUrgencyBannerProps) {
  if (urgentCount === 0) return null;

  return (
    <div
      className="flex shrink-0 items-center gap-3 px-6 py-2.5"
      style={{
        background: 'var(--alert-red-tint)',
        borderBottom: '1px solid var(--terracotta-tint)',
      }}
    >
      <span className="ti-urgent-dot" />
      <span
        style={{
          fontSize: 13,
          fontWeight: 600,
          color: 'var(--terracotta)',
          letterSpacing: '-0.005em',
        }}
      >
        {urgentCount} urgent {urgentCount === 1 ? 'item needs' : 'items need'} attention
      </span>
      <button
        type="button"
        onClick={onJump}
        style={{
          marginLeft: 'auto',
          padding: '5px 11px',
          borderRadius: 7,
          background: 'var(--cream-1)',
          border: '1px solid var(--terracotta-tint)',
          color: 'var(--terracotta)',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: 'var(--font-body)',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
        }}
      >
        Review now <Icon kind="arrow-r" size={11} stroke={2.2} />
      </button>
    </div>
  );
}
